var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WorkBaseTabs',_vm._b({attrs:{"content-class":"w-tabs__content--table"}},'WorkBaseTabs',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }